import { $fetch } from 'ofetch';
import { useRuntimeConfig } from '#app';
import { useUserAuthStore } from '@/entities/User/store/auth';
import checkPath from '@/shared/utils/check-path';
import type { ApiErrorResponseInterface } from '@/shared/types/api';

enum ErrorCode {
	BadRequest = 400,
	Unauthorized = 401,
	Forbidden = 403,
	NotFound = 404,
}

enum RequestMethod {
	Get = 'GET',
	Post = 'POST',
	Put = 'PUT',
	Delete = 'DELETE',
}

const retryStatusCodes = [ErrorCode.Unauthorized];

export default () => {
	const runtimeConfig = useRuntimeConfig();

	const fetchInstance = $fetch.create({
		baseURL: runtimeConfig.public.BASE_API as string ?? '/api',
		retryStatusCodes,
		onRequest({ options }) {
			options.headers.set('Authorization', `Basic ${btoa('admin:%j%3t%M7G5q68X')}`);
		},
		async onResponseError({ response }) {
			if (retryStatusCodes.includes(response.status)) {
				const { refresh } = useUserAuthStore();
				await refresh();
			}
		},
	});

	const $get = async (path: string, params: Record<string, unknown> = {}) => {
		checkPath(path);

		return await fetchInstance(path, {
			method: RequestMethod.Get,
			...params,
		}).catch((e: ApiErrorResponseInterface) => e);
	};

	const $post = async (path: string, params: Record<string, unknown> = {}) => {
		checkPath(path);

		return await fetchInstance(path, {
			method: RequestMethod.Post,
			...params,
		}).catch((e: ApiErrorResponseInterface) => e);
	};

	const $put = async (path: string, params: Record<string, unknown> = {}) => {
		checkPath(path);

		return await fetchInstance(path, {
			method: RequestMethod.Put,
			...params,
		}).catch((e: ApiErrorResponseInterface) => e);
	};

	const $delete = async (path: string, params: Record<string, unknown> = {}) => {
		checkPath(path);

		return await fetchInstance(path, {
			method: RequestMethod.Delete,
			...params,
		}).catch((e: ApiErrorResponseInterface) => e);
	};

	return { $get, $post, $put, $delete };
};
